import React, { createContext, useContext, useEffect, useState } from "react";

const WishlistContext = createContext(null);

export function WishlistProvider({ children }) {
  const [items, setItems] = useState(() => {
    try { return JSON.parse(localStorage.getItem("dms_wishlist") || "[]"); } catch { return []; }
  });

  useEffect(() => { localStorage.setItem("dms_wishlist", JSON.stringify(items)); }, [items]);

  const has = (slug) => items.some((i) => i.slug === slug);
  const toggle = (product) => {
    setItems((prev) => prev.some((i) => i.slug === product.slug)
      ? prev.filter((i) => i.slug !== product.slug)
      : [...prev, { slug: product.slug, title: product.title, price: product.price, img: product.img, category: product.category, addedAt: Date.now() }]);
  };
  const remove = (slug) => setItems((prev) => prev.filter((i) => i.slug !== slug));
  const clear = () => setItems([]);

  return (
    <WishlistContext.Provider value={{ items, has, toggle, remove, clear, count: items.length }}>
      {children}
    </WishlistContext.Provider>
  );
}

export const useWishlist = () => useContext(WishlistContext);
